import React, {useState, useEffect} from "react";
import { Box, Stack, Typography, Card, CardContent, Button, Divider, TextField, FormControl, Link, InputLabel, Select,Breadcrumbs, MenuItem, FormControlLabel, Checkbox, Grid } from "@mui/material";
import { FlexStart, FlexCenter, FlexRowCenter, FlexColCenter } from "components/FlexBox/FlexBox";
import ImageUploader from "components/Images/ImageUploader";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import CountertopsOutlinedIcon from "@mui/icons-material/CountertopsOutlined";
import ShowerOutlinedIcon from "@mui/icons-material/ShowerOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import axios from "axios";
import { baseURL } from "services/API";
import SendIcon from '@mui/icons-material/Send';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import ApartmentIcon from "@mui/icons-material/Apartment";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useLocation } from "react-router-dom";
import FlexBetween from "components/FlexBetween";
import TopSnack from "components/TopSnack";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const facilityIcons = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#52524e",
};

const formatNumberString = (numberString) => {
	const number = Number(numberString);
	if (isNaN(number)) {
		return "Invalid number string";
	}
	return number.toLocaleString();
};

const unitSchema = yup.object().shape({
  unit_name: yup.string().required("Please input the name of the unit "),
  unit_rent: yup.number().required("This field is required"),
  unit_rent_cycle: yup.string().required("This field is required"),
  unit_type: yup.string().required("This field is required"),
  rent_currency: yup.string().required("This field is required"),
  number_of_bedrooms: yup.number().required("This field is required"),
  number_of_bathrooms: yup.number().required("This field is required"),
  has_down_payment: yup.boolean(),
  has_security_fee: yup.boolean(),
  unit_cycle_down_payment: yup.number().when("has_down_payment", {
    is: true,
    then: yup.number().min(1,"A minimum of one cycle/month is required").required("This field is required"),
  }),
  unit_rent_security_fee: yup.number().when("has_security_fee", {
    is: true,
    then: yup.number().required("This field is required"),
  }),
});


const UnitCreate = () => {
	const token = useSelector((state) => state.token)
  	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [files, setFiles] = useState([]);
	const [open, setOpen] = React.useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const id  = useSelector((state) => state.property_id);


	const [unitName, setUnitName] = useState("");
	const [rentCurrency, setRentCurrency] = useState("");
	const [rentCycle, setRentCycle] = useState("");
	const [unitType, setUnitType] = useState("");
	const [unitRent, setUnitRent] = useState(0);
	const [bedrooms, setBedrooms] = useState("");
	const [bathrooms, setBathrooms] = useState("");
	const [insideKitchen, setInsideKitchen] = useState(false);
	const [insideBathroom, setInsideBathroom] = useState(false);
	const [dstv, setDstv] = useState(false);
	const [fibre, setFibre] = useState(false);
	const [funished, setFurnished] = useState(false);
	const [store, setStore] = useState(false);
	const [hasDownPayment, setHasDownPayment] = useState(false);
  const [downPaymentMonths, setDownPaymentMonths] = useState(1)
	const [downPayment, setDownPayment] = useState(0);
	const [hasSecurityFee, setHasSecurityFee] = useState(false);
	const [securityFee, setSecurityFee] = useState("");
	const [useDeclaredRentForDisplay, setUseDeclaredRentForDisplay] = useState(false);
	const [declaredUnitRent, setDeclaredUnitRent] = useState("");
	const [unitData, setUnitData] = useState({
    related_rental: id,
    has_security_fee: false,
    has_down_payment: true,
  });
	const [submittingData, setSubmittingData] = useState(false);
	const [errors, setErrors] = React.useState({});
  const [openSnack, setOpenSnack] = useState({open: false,message: "",severity: "",});
  const [uploading, setUploading] = useState(false);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack({ ...openSnack, open: false, message: "", severity: "" });
  };


	const handleChangeUnitName = (event) => {
		setUnitName(event.target.value);
		setUnitData({...unitData, unit_name: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'unit_name': `The Unit Name is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "unit_name": "" }));
		}
	};

	const handleChangeRentCurrency = (event) => {
		setRentCurrency(event.target.value);
		setUnitData({...unitData, rent_currency: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'rent_currency': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "rent_currency": "" }));
		}
	};

	const handleChangeRentCycle = (event) => {
		setRentCycle(event.target.value);
		setUnitData({...unitData, unit_rent_cycle: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'unit_rent_cycle': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "unit_rent_cycle": "" }));
		}
	};

	const handleChangeUnitType = (event) => {
		setUnitType(event.target.value);
		setUnitData({...unitData, unit_type: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'unit_type': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "unit_type": "" }));
		}
	};

	const handleChangeUnitRent = (event) => {
		const { value } = event.target;
    setUnitRent(value);
    setDownPayment(parseFloat(value) * downPaymentMonths);
    if (hasSecurityFee === true) {
      setSecurityFee(value);
      setUnitData({
        ...unitData,
        unit_rent: value,
        unit_rent_security_fee: value,
        unit_cycle_down_payment: parseFloat(value) * downPaymentMonths,
        down_payment_periods_covered: downPaymentMonths,
      });
    } else {
      setUnitData({
        ...unitData,
        unit_rent: value,
        unit_cycle_down_payment: parseFloat(value) * downPaymentMonths,
        down_payment_periods_covered: downPaymentMonths,
      });
    }
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, unit_rent: `This field is required` }));
    } else {
      setErrors((prev) => ({ ...prev, unit_rent: "" }));
    }
	};

	const handleChangeBedrooms = (event) => {
		setBedrooms(event.target.value);
		setUnitData({...unitData, number_of_bedrooms: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'number_of_bedrooms': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "number_of_bedrooms": "" }));
		}
	};

	const handleChangeBathrooms = (event) => {
		setBathrooms(event.target.value);
		setUnitData({...unitData, number_of_bathrooms: event.target.value})
		if (!event.target.value.trim()) {
      		setErrors((prev) => ({ ...prev, 'number_of_bathrooms': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "number_of_bathrooms": "" }));
		}
	};

	const handleChangeInsideBathroom = (event) => {
		setInsideBathroom(event.target.checked);
		setUnitData({...unitData, has_inside_bathroom: event.target.value})
	};
	
	const handleChangeInsideKitchen = (event) => {
		setInsideKitchen(event.target.checked);
		setUnitData({...unitData, has_inside_kitchen: event.target.value})
	}

	const handleChangeDstv = (event) => {
		setDstv(event.target.checked);
		setUnitData({...unitData, has_dstv_connection: event.target.value})
	};
	
	const handleChangeFibre = (event) => {
		setFibre(event.target.checked);
		setUnitData({...unitData, has_fibre_connection: event.target.value})
	};

	const handleChangeStore = (event) => {
		setStore(event.target.checked);
		setUnitData({...unitData, has_store: event.target.value})
	};
	
	const handleChangeFurnished = (event) => {
		setFurnished(event.target.checked);
		setUnitData({...unitData, is_fully_furnished: event.target.value})
	};

	const handleChangeHasDownPayment= (event) => {
    setDownPayment(0);
    setDownPaymentMonths(0);
		setHasDownPayment(event.target.checked);
		setUnitData({...unitData, has_down_payment: event.target.checked})
	};

	const handleChangeHasSecurityFee = (event) => {
		setHasSecurityFee(event.target.checked);
		if (event.target.checked===true){
      setSecurityFee(unitRent);
      setUnitData({ ...unitData, has_security_fee: event.target.checked, unit_rent_security_fee: unitRent });
    } else {
      setSecurityFee(0);
      setUnitData({ ...unitData, has_security_fee: event.target.checked, unit_rent_security_fee: 0 });
    }
	};

	const handleChangeDownPayment= (event) => {
    const { value } = event.target;
		setDownPaymentMonths(value);
		setDownPayment(value * unitRent);
		setUnitData({...unitData, unit_cycle_down_payment: (value * unitRent), down_payment_periods_covered: value })
    	if (!toString(value).trim()) {
      		setErrors((prev) => ({ ...prev, 'unit_cycle_down_payment': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "unit_cycle_down_payment": "" }));
		}
	};

	const handleChangeSecurityFee = (event) => {
    const {value} = event.target;
		setSecurityFee(value);
		setUnitData({...unitData, unit_rent_security_fee: value})
    if (!toString(value).trim()) {
      		setErrors((prev) => ({ ...prev, 'unit_rent_security_fee': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "unit_rent_security_fee": "" }));
		}
	};

  // 1. Move image upload logic to a separate function that takes a unitId
  const uploadUnitImages = async (unitId) => {
    if (!files.length) return; // No files to upload

    setUploading(true);
    const formData = new FormData();
    formData.append("unit_id", unitId);

    files.forEach((file) => {
      formData.append("images", file);
    });

    try {
      await axios.post(
        `${baseURL}/landlords/houses/images/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOpenSnack({
        open: true,
        message: "Images uploaded successfully!",
        severity: "success",
      });
      setFiles([]); // Clear files after upload
    } catch (error) {
      setOpenSnack({
        open: true,
        message: "Image upload failed. Please try again.",
        severity: "error",
      });
    } finally {
      setUploading(false);
    }
  };

  const declaredRentRatio =
    useDeclaredRentForDisplay && unitRent && declaredUnitRent && Number(unitRent) > 0
      ? Math.round((Number(declaredUnitRent) / Number(unitRent)) * 100)
      : null;

  const validateDeclaredRent = () => {
    if (!useDeclaredRentForDisplay) return true;
    const actual = Number(unitRent);
    const declared = Number(declaredUnitRent);
    if (!declaredUnitRent || Number.isNaN(declared) || declared <= 0) {
      setErrors((prev) => ({
        ...prev,
        declared_unit_rent: "Declared rent is required when using declared rent on receipts.",
      }));
      return false;
    }
    if (!actual || declared >= actual) {
      setErrors((prev) => ({
        ...prev,
        declared_unit_rent: "Declared rent must be less than actual unit rent.",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, declared_unit_rent: "" }));
    return true;
  };

  const handleChangeUseDeclaredRent = (event) => {
    const checked = event.target.checked;
    setUseDeclaredRentForDisplay(checked);
    setUnitData((prev) => ({
      ...prev,
      use_declared_rent_for_display: checked,
      ...(checked ? {} : { declared_unit_rent: undefined }),
    }));
    if (!checked) {
      setDeclaredUnitRent("");
      setErrors((prev) => ({ ...prev, declared_unit_rent: "" }));
    }
  };

  const handleChangeDeclaredUnitRent = (event) => {
    const value = event.target.value;
    setDeclaredUnitRent(value);
    setUnitData((prev) => ({
      ...prev,
      use_declared_rent_for_display: true,
      declared_unit_rent: value,
    }));
    if (value && unitRent && Number(value) >= Number(unitRent)) {
      setErrors((prev) => ({
        ...prev,
        declared_unit_rent: "Declared rent must be less than actual unit rent.",
      }));
    } else if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        declared_unit_rent: "Declared rent is required when checkbox is enabled.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, declared_unit_rent: "" }));
    }
  };

  // 2. Update your unit creation handler to call image upload if files exist
  const handleRentalUnitFormSubmit = async () => {
    try {
      await unitSchema.validate(unitData, { abortEarly: false });
    } catch (error) {
      const newError = {};
      error.inner.forEach((err) => {
        newError[err.path] = err.message;
      });
      setErrors(newError);
      return;
    }

    if (!validateDeclaredRent()) {
      return;
    }

    const payload = { ...unitData };
    if (!useDeclaredRentForDisplay) {
      delete payload.declared_unit_rent;
      payload.use_declared_rent_for_display = false;
    } else {
      payload.use_declared_rent_for_display = true;
      payload.declared_unit_rent = String(declaredUnitRent);
    }

    try {
      setSubmittingData(true);
      const response = await axios.post(`${baseURL}/landlords/rentals/units`, payload);
      setSubmittingData(false);

      setOpenSnack({
        open: true,
        message: "Unit Created Successfully",
        severity: "success",
      });

      // If files exist, upload them using the returned unit info
      if (files.length && response?.data) {
        // Try different possible response structures
        const unitId = response.data.unit_id || response.data.data?.id || response.data.data?.unit_id || response.data.id;
        if (unitId) {
          await uploadUnitImages(unitId);
        } else {
          console.warn("Unit ID not found in response, images will not be uploaded");
        }
      }

      navigate("/propertyDetailsTab");
    } catch (err) {
      setOpenSnack({ open: true, message: "Unit Creation Failed", severity: "error" });
      console.log(err);
    }
  };

  return (
    <Box m="20px" p="20px">
		<Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            onClick={() => navigate("/propertyDetailsTab")}
          >
            <ApartmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Property Details
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center" }}
            color="text.primary"
          >
            <b>Create Unit</b>
          </Typography>
        </Breadcrumbs>
		    <Typography variant="h4" marginBottom={"10px"}>Unit Details</Typography>
        <Grid container spacing={2}>
			
          <Grid item xs={12} sm={6}>
            <Stack spacing={3} sx={{ marginBottom: "10px" }}>
              <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Unit Name"
                  onChange={handleChangeUnitName}
                  fullWidth={true}
                  margin="dense"
                  name="unit_name"
                  error={Boolean(errors.unit_name)}
                  helperText={errors.unit_name}
                  autoFocus
                />

                <TextField
                  required={false}
                  id="outlined-description"
                  label="Unit Description"
                  onChange={(e) => setUnitData({ ...unitData, description: e.target.value })}
                  fullWidth
                  margin="dense"
                  name="description"
                  value={unitData.description || ""}
                  error={Boolean(errors.description)}
                  helperText={errors.description}
                  multiline
                  rows={3}
                  placeholder="Enter a description for this unit..."
                />

                <FlexBetween sx={{ marginY:"10px" }}>
                  <TextField
                    select
                    label="Unit Type"
                    labelId="unit-type"
                    value={unitType}
                    sx={{ width:"49%" }}
                    name="unit_type"
                    error={Boolean(errors.unit_type)}
                    helperText={errors.unit_type}
                    onChange={handleChangeUnitType}
                  >
                    <MenuItem value="REGULAR">REGULAR</MenuItem>
                    <MenuItem value="CONDOMINIUM">CONDOMINIUM</MenuItem>
                    <MenuItem value="SEMI-DETACHED">SEMI DETACHED</MenuItem>
                    <MenuItem value="COMMERCIAL">COMMERCIAL</MenuItem>
                  </TextField>

                  <TextField
                    select
                    label="Rent Cycle"
                    labelId="rent-cycle"
                    value={rentCycle}
                    sx={{ width:"49%" }}
                    name="unit_rent_cycle"
                    error={Boolean(errors.unit_rent_cycle)}
                    helperText={errors.unit_rent_cycle}
                    onChange={handleChangeRentCycle}
                  >
                    <MenuItem value="MONTHLY">MONTHLY</MenuItem>
                    <MenuItem value="QUARTERLY">QUARTERLY</MenuItem>
                    <MenuItem value="SHORT">SHORT TERM</MenuItem>
                  </TextField>
                </FlexBetween>

                <FlexBetween sx={{ marginY:"10px" }}>
                  <TextField
                    select
                    label="Rent Currency"
                    labelId="rent-currency"
                    value={rentCurrency}
                    sx={{ width:"49%" }}
                    name="rent_currency"
                    error={Boolean(errors.rent_currency)}
                    helperText={errors.rent_currency}
                    onChange={handleChangeRentCurrency}
                  >
                    <MenuItem value="UGX">UGX</MenuItem>
                    <MenuItem value="USD">USD</MenuItem>
                  </TextField>

                  <TextField
                    required
                    id="outlined-required"
                    label="Unit Rent in UGX per Month"
                    onChange={handleChangeUnitRent}
                    fullWidth={true}
                    margin="dense"
                    type="number"
                    name="unit_rent"
                    sx={{ width:"49%" }}
                    error={Boolean(errors.unit_rent)}
                    helperText={errors.unit_rent}
                    // autoFocus
                  />	
                </FlexBetween>

                <Box sx={{ marginY: "10px", borderTop: "1px solid #eee", paddingTop: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={useDeclaredRentForDisplay}
                        onChange={handleChangeUseDeclaredRent}
                      />
                    }
                    label="Use declared rent on receipts"
                  />
                  {useDeclaredRentForDisplay && (
                    <TextField
                      fullWidth
                      margin="dense"
                      type="number"
                      label="Declared unit rent (UGX)"
                      value={declaredUnitRent}
                      onChange={handleChangeDeclaredUnitRent}
                      error={Boolean(errors.declared_unit_rent)}
                      helperText={
                        errors.declared_unit_rent ||
                        (declaredRentRatio != null
                          ? `Actual rent: ${formatNumberString(unitRent)} — Receipts will show ${formatNumberString(declaredUnitRent)} (${declaredRentRatio}%)`
                          : "Must be less than actual unit rent. Used on tenant receipts only.")
                      }
                    />
                  )}
                </Box>

                <FlexBetween sx={{ marginY:"10px" }}>
                  <TextField
                    select
                    label="Number of Bedrooms"
                    labelId="bedrooms"
                    value={bedrooms}
                    sx={{ width:"49%" }}
                    name="number_of_bedrooms"
                    error={Boolean(errors.number_of_bedrooms)}
                    helperText={errors.number_of_bedrooms}
                    onChange={handleChangeBedrooms}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </TextField>

                  <TextField
                    select
                    label="Number of Bathrooms"
                    labelId="bathrooms"
                    value={bathrooms}
                    sx={{ width:"49%" }}
                    name="number_of_bathrooms"
                    error={Boolean(errors.number_of_bathrooms)}
                    helperText={errors.number_of_bathrooms}
                    onChange={handleChangeBathrooms}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </TextField>
                </FlexBetween>
                
              </Box>
              
              <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
                <Typography variant="h5">Amenities (Select all that apply to the unit)</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={2}>
                      <FlexCenter>
                        <ChairOutlinedIcon sx={facilityIcons} />
                        <FormControlLabel control={<Checkbox checked={insideKitchen} onChange={handleChangeInsideKitchen}/>} label="Has Inside Kitchen?" />
                      </FlexCenter>
                      <FlexCenter>
                        <BedOutlinedIcon sx={facilityIcons} />
                        <FormControlLabel control={<Checkbox checked={insideBathroom} onChange={handleChangeInsideBathroom}/>} label="Has Inside Bathroom?" />
                      </FlexCenter>
                      <FlexCenter>
                        <CountertopsOutlinedIcon sx={facilityIcons} />
                        <FormControlLabel control={<Checkbox checked={dstv} onChange={handleChangeDstv}/>} label="Has Dstv Connection?" />
                      </FlexCenter>
                      <FlexCenter>
                        <WifiOutlinedIcon sx={facilityIcons} />
                        <FormControlLabel label="Has Fibre Connection?" control={<Checkbox checked={fibre} onChange={handleChangeFibre}/>}  />
                      </FlexCenter>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={2}>
                      <FlexCenter>
                        <ChairOutlinedIcon sx={facilityIcons} />
                        <FormControlLabel label="Is Fully Furnished?" control={<Checkbox checked={funished} onChange={handleChangeFurnished}/>}  />
                      </FlexCenter>
                      <FlexCenter>
                        <StorefrontIcon sx={facilityIcons} />
                        <FormControlLabel label="Has a Store?" control={<Checkbox checked={store} onChange={handleChangeStore}/>}  />
                      </FlexCenter>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
          </Grid>
          <Grid item sx={{ display: { xs: "none", sm: "block" } }} xs={12} sm={6}>
            <Card sx={{marginBottom: "25px"}}>
              <CardContent sx={{ padding: 0 }}>
                <FlexStart sx={{ padding: "16px" }}>
                {/* <LandLordAvatar /> */}
                  <Box sx={{ marginLeft: "8px" }}>
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      Add Unit Images
                    </Typography>
                  </Box>
                </FlexStart>
                <Divider />
                <Stack spacing={3} sx={{ padding: "16px 16px 5px 16px" }}>
                  <ImageUploader 
                    files={files} 
                    setFiles={setFiles}
                  />
                </Stack>
              </CardContent>
            </Card>

            <Card >
              <CardContent sx={{ padding: 0 }}>
                <FlexStart sx={{ padding: "16px" }}>
                {/* <LandLordAvatar /> */}
                  <Box sx={{ marginLeft: "8px" }}>
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>Terms and Conditions</Typography>
                  </Box>
                </FlexStart>
                <Divider />
                <Stack spacing={3} sx={{ padding: "16px" }}>
                  <FlexColCenter>
                    {/* <FormControlLabel labelPlacement="start" label="Does the Unit have an intital deposit payment?" control={<Checkbox checked={hasDownPayment} onChange={handleChangeHasDownPayment}/>}  />
                    {hasDownPayment && ( */}
                      <FlexBetween sx={{ width:"100%" }}>
                        <TextField  fullWidth type="number" value={downPaymentMonths}  label="Cycles/months covered in the intial payment" onChange={handleChangeDownPayment} error={Boolean(errors.unit_cycle_down_payment)} helperText={errors.unit_cycle_down_payment} />
                        <TextField name="unit_cycle_down_payment" fullWidth type="number" disabled value={downPayment} label="Total Initial Deposit?" sx={{ marginLeft:"5px " }} />
                      </FlexBetween>
                    {/* )} */}
                  </FlexColCenter>
                  <FlexColCenter>
                    <FormControlLabel labelPlacement="start" label="Does the Unit have a security deposit?" control={<Checkbox checked={hasSecurityFee} onChange={handleChangeHasSecurityFee}/>}  />
                    {hasSecurityFee && (
                      <TextField  sx={{ width:"50%" }} type="number" value={securityFee} label="Input secuity deposit amount" onChange={handleChangeSecurityFee} error={Boolean(errors.unit_rent_security_fee)} helperText={errors.unit_rent_security_fee} />
                    )}
                  </FlexColCenter>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Button variant="contained" endIcon={<SendIcon />} onClick={handleRentalUnitFormSubmit} sx={{padding:"15px"}}>Submit Unit Details</Button>
          </Grid>
			</Grid>
      <TopSnack
				open={openSnack.open}
				handleCloseSnack={handleCloseSnack}
				message={openSnack.message}
				severity={openSnack.severity}
      />
    </Box>
  );
};

export default UnitCreate;